import React from 'react';

import { CaptionText } from '@prisjakt/ui/text/variants';
import * as S from './styles';

type OwnProps = {
  ariaLabel: string;
  handleOnClick: () => void;
  id: Number | String;
  image?: React.ReactNode;
  maxWidth?: number;
  name: string;
  order?: number;
  selected: boolean;
  subtitle?: React.ReactNode;
  title?: string;
  type?: 'radio' | 'button';
  className?: string;
};

const SelectableButton = ({
  className,
  ariaLabel,
  handleOnClick,
  id,
  image,
  maxWidth,
  name,
  order,
  selected,
  subtitle,
  title,
  type = 'button',
}: OwnProps) => {
  return (
    <S.Label
      className={className}
      htmlFor={`${type}-${id}`}
      selected={selected}
      onClick={e => {
        e.preventDefault();
        handleOnClick();
      }}
      aria-label={ariaLabel}
      order={order}
      tabIndex={0}
    >
      <S.Wrapper maxWidth={maxWidth}>
        {image}
        {title && (
          <S.TextWrapper>
            <S.Input type={type} name={name} id={`${type}-${id}`} />
            <S.Title>{title}</S.Title>
            {subtitle && <CaptionText>{subtitle}</CaptionText>}
          </S.TextWrapper>
        )}
      </S.Wrapper>
    </S.Label>
  );
};

export default SelectableButton;
